"use client";
import { useEffect } from "react";
import Skeleton from "react-loading-skeleton";
import styles from "./index.module.css";
import StoreBox from "../store/template/default/store-box";
import { useToken } from "../../lib/context/auth-context";
import { useMarketplaceOrgs } from "../organisation/useMarketplaceOrgs";
import OrgList from "./orgList";
import SkeletonCard from "../store/template/default/skeleton-card";
import {
  setAccessPoint,
  setAccessPointId,
  setAccessPoints,
  setOrganisation,
} from "../slice/accessOrg-slice";
import { useAppDispatch } from "../slice/hooks";
import { setActiveCategory, setCategories } from "../slice/category-slice";

const MarketplaceSkeleton = () => {
  return (
    <div style={{ width: "100%" }}>
      <div style={{ marginBottom: "2rem" }}>
        <Skeleton height={400} width="100%" />
      </div>

      {Array.from({ length: 3 }).map((_, idx) => (
        <div style={{ width: "100%" }} key={idx}>
          <div style={{ margin: "0 auto", maxWidth: "1200px" }}>
            <SkeletonCard />
          </div>
        </div>
      ))}
    </div>
  );
};

const MarketPlaceStore = (props) => {
  const { urlData, serverToken } = props;
  const { token } = useToken();
  const dispatch = useAppDispatch();
  const activeToken = token || serverToken;

  useEffect(() => {
    dispatch(setAccessPointId(null));
    dispatch(setAccessPoint(null));
    dispatch(setAccessPoints([]));
    dispatch(setOrganisation(null));
    dispatch(setActiveCategory(null));
    dispatch(setCategories(null));
  }, []);

  const { state, switching, handleSwitch, openPage, isLoading, isFetching } =
    useMarketplaceOrgs(urlData, activeToken);
  const showOrganisationSkeleton =
    (isLoading || isFetching) && state.accessPoints.length === 0;

  return (
    <StoreBox {...props} isSwitching={switching}>
      <div className={styles.marketPlaceContainer}>
        {switching ? (
          <MarketplaceSkeleton />
        ) : (
          <>
            {/* <div className={styles.marketPlaceHeader}>
              <h1>Welcome to the Circleplug Stores</h1>
            </div> */}

            {state.accessPoints.length > 0 ? (
              <OrgList
                state={state}
                handleSwitch={handleSwitch}
                openPage={openPage}
                token={activeToken}
                isLoading={isLoading}
                isFetching={isFetching}
              />
            ) : showOrganisationSkeleton ? (
              <div className={styles.marketPlaceOrganisations}>
                {Array.from({ length: 5 }).map((_, i) => (
                  <div key={i} className={styles.organisation}>
                    <div className={styles.organisationInfo}>
                      <div style={{ marginRight: "1rem", flexShrink: 0 }}>
                        <Skeleton width={70} height={70} circle />
                      </div>

                      <div
                        className={styles.textInfo}
                        style={{ width: "100%" }}
                      >
                        <div style={{ marginBottom: 5 }}>
                          <Skeleton width={200} height={24} />
                        </div>
                        <div style={{ marginBottom: 2 }}>
                          <Skeleton width={300} height={18} />
                        </div>
                        <div>
                          <Skeleton width={300} height={15} />
                        </div>
                      </div>
                    </div>
                    <div
                      className={styles.organisationCategories}
                      aria-hidden
                      style={{ paddingLeft: "3rem" }}
                    >
                      {Array.from({ length: 5 }).map((_, j) => (
                        <div
                          key={j}
                          style={{
                            width: "30rem",
                            height: "25rem",
                            borderRadius: 7,
                            background: "#f0f0f0",
                            flex: "0 0 30rem",
                            marginRight: "1rem",
                          }}
                        />
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className={styles.marketPlaceEmptyState}>
                <div className={styles.marketPlaceEmptyArt} aria-hidden="true">
                  <span className={styles.emptyStoreRoof} />
                  <span className={styles.emptyStoreBody}>
                    <span />
                    <span />
                    <span />
                  </span>
                </div>
                <div className={styles.marketPlaceEmptyCopy}>
                  <h2>No stores available</h2>
                  <p>
                    We could not find any marketplace stores right now. Please
                    check back soon.
                  </p>
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </StoreBox>
  );
};

export default MarketPlaceStore;
